// Polices du thème Elysium, chargées à la demande (VtM et panneau Vampire de l'accueil).
export const loadVtmFonts = () => {
  if (document.getElementById('vtm-fonts')) return;
  const link = document.createElement('link');
  link.id = 'vtm-fonts';
  link.rel = 'stylesheet';
  link.href = 'https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700&family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;0,700;1,500&display=swap';
  document.head.appendChild(link);
};
